import React, { useState } from "react";
import { ImageLoadingPlaceholder } from "./ImageLoadingPlaceholder";

export interface ImageWithLoadingPlaceholderProps
  extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  placeholderHeight: number;
}

export const ImageWithLoadingPlaceholder = React.memo(function ImageWithLoadingPlaceholder(
  props: ImageWithLoadingPlaceholderProps
): JSX.Element {
  const [hasLoaded, setHasLoaded] = useState(false);

  const { placeholderHeight, ...imgProps } = props;

  return (
    <div className="ImageWithLoadingPlaceholder">
      <div style={{ display: hasLoaded ? "none" : "block" }}>
        <ImageLoadingPlaceholder style={{ height: props.placeholderHeight }} />
      </div>
      <img
        {...imgProps}
        onLoad={() => setHasLoaded(true)}
        style={{ display: hasLoaded ? "block" : "none" }}
      />
    </div>
  );
});
